import { render, staticRenderFns } from "./SmBtn.vue?vue&type=template&id=2633ace6&scoped=true&"
import script from "./SmBtn.vue?vue&type=script&lang=ts&"
export * from "./SmBtn.vue?vue&type=script&lang=ts&"
import style0 from "./SmBtn.vue?vue&type=style&index=0&id=2633ace6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633ace6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
